// extracted by mini-css-extract-plugin
export default {"section":"HotBid_section__V-OV2","wrapper":"HotBid_wrapper__xDsN7","title":"HotBid_title__JGnvl","inner":"HotBid_inner__rO3cE","card":"HotBid_card__NIAPj"};